import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AppService } from '../../_services/app.service';

@Component({
  selector: 'app-client-header',
  templateUrl: './client-header.component.html',
  styleUrls: ['./client-header.component.css']
})
export class ClientHeaderComponent implements OnInit {

  title = '';
  client: any = {};

  constructor(
    public appSvc: AppService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.init();
    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationEnd) {
      }
    })
    this.appSvc.updateData.subscribe((res: any) => {
      this.init();
    });
  }

  init() {
    if (this.appSvc.clients && this.appSvc.clients.length && this.appSvc.selectedClient) {
      this.client = this.appSvc.selectedClient;
      // this.clients = this.appSvc.clients;
    } else {
      setTimeout(() => {
        this.init();
      }, 500);
    }
  }

}
